// extracted by mini-css-extract-plugin
export default {"backLink":"style_backLink__UjC7W"};